import {react, use, useEffect} from "react";
import { Link } from "react-router-dom";

export default function ThankYou() {

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.heading}>🎉 Thank You!</h1>
        <p style={styles.text}>
          Your order has been placed successfully.
          <br />
          We’ll send you a confirmation email shortly.
        </p>
        <Link to="/" style={styles.button}>
          Continue Shopping
        </Link>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "80vh",
    backgroundColor: "#f7f7f7",
    padding: "20px",
  },
  card: {
    backgroundColor: "#fff",
    padding: "40px 60px",
    borderRadius: "10px",
    boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
    textAlign: "center",
    maxWidth: "500px",
    width: "100%",
  },
  heading: {
    fontSize: "2.5rem",
    marginBottom: "20px",
    color: "#4CAF50",
  },
  text: {
    fontSize: "1.2rem",
    marginBottom: "30px",
  },
  button: {
    display: "inline-block",
    padding: "12px 25px",
    backgroundColor: "#4CAF50",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "5px",
    fontWeight: "bold",
    transition: "background-color 0.3s",
  },
};
